import { get, put, post, remove } from '../services/common/common.service';
import { oosBillSetsEndPoints, commonEndPoints } from '../constants/endpoint';


export const fetchhOosBillSetsData = (payload) =>{
  return get(`${oosBillSetsEndPoints.fetchOosBillSets}?name=${payload.name}&pageIndex=${payload.pageIndex}&recordCount=${payload.recordCount}`);
}


export const fetchCountriesData = (payload) =>
  get(commonEndPoints.countries, payload);

export const fetchCurrenciesData = (payload) =>
  get(commonEndPoints.currencies, payload);

export const fetchServiceTypeData = (payload) =>
  get(commonEndPoints.serviceType, payload);

export const fetchOosBillSetsById = (payload) =>
  get(`${oosBillSetsEndPoints.fetchOosBillSetsById}?billSetID=${payload}&recordCount=25&pageIndex=1`);

export const addBillSets = (payload) =>
  post(oosBillSetsEndPoints.addBillSets, payload);

export const updateBillSets = (payload) =>
  put(oosBillSetsEndPoints.updateBillSets, payload);

export const deleteBillSet = (payload) =>
  remove(`${oosBillSetsEndPoints.deleteBillSet}?billSetID=${payload.billSetId}&isUsedInContract=${payload.isUsedInContract}`);